import { AppRoutingModule } from "../app-routing.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FilterPipe } from "../_pipes/filter.pipe";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppButtonComponent } from "./button/app-button.component";
import { AdminUserFormatterPipe } from "./../_pipes/admin-user-formatter.pipe";
import { UrlPipe } from "./../_pipes/url.pipe";
import { SpacesToDashesPipe } from "./../_pipes/spaces-to-dashes.pipe";
// import { NgxMdModule } from "ngx-md";
import { TrackScrollDirective } from "./../_directives/scroll.directive";
// import { SpinnerModule } from "angular2-spinner/dist";
import { DatexPipe } from "../_pipes/datex.pipe";

@NgModule({
  imports: [
    CommonModule,
    AppRoutingModule,
    // SpinnerModule,
    // NgxMdModule.forRoot(),
  ],
  declarations: [
    AdminUserFormatterPipe,
    DatexPipe,
    TrackScrollDirective,
    AppButtonComponent,
    FilterPipe,
    SpacesToDashesPipe,
    UrlPipe,
    TrackScrollDirective,
  ],
  exports: [
    AdminUserFormatterPipe,
    DatexPipe,
    FilterPipe,
    AppRoutingModule,
    CommonModule,
    FilterPipe,
    FormsModule,
    AppButtonComponent,
    ReactiveFormsModule,
    SpacesToDashesPipe,
    TrackScrollDirective,
    UrlPipe,
    // NgxMdModule,
  ],
  providers: [],
})
export class SharedModule {}
